interface AddressValueProps {
  streetAddress?: string;
  apartment?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
}

export function AddressValue({
  streetAddress,
  apartment,
  city,
  state,
  country,
  zipCode,
}: AddressValueProps) {
  return (
    <div>
      {streetAddress && <p className="mb-0">{streetAddress}</p>}
      {apartment && <p className="mb-0">{apartment}</p>}
      {city && <p className="mb-0">{city}</p>}
      {state && <p className="mb-0">{state}</p>}
      {country && (
        <p className="mb-0">
          {country}
          {zipCode && `, ${zipCode}`}
        </p>
      )}
    </div>
  );
}
